module.exports = "https://static.wagwalking.com/_next/static/images/pet-11-89fb68dce2da3004b2fe827c43ca6974.png";